import React from 'react';
import { Button, Text, Flex, ChatMessage } from 'pcln-design-system';
import { TravelBotLogoImage } from './TravelBotLogoImage';
/**
 * @public
 */
function SignInMarkerComponent(props) {
    var signedIn = props.signedIn, onSigninClick = props.onSigninClick;
    var onClickHandler = function () {
        var _a, _b;
        // @ts-ignore
        (_b = (_a = window.PCLN) === null || _a === void 0 ? void 0 : _a.pclnEventDispatcher) === null || _b === void 0 ? void 0 : _b.dispatch('GLOBAL_PCLN_LAUNCH_SIGNIN_MODAL');
    };
    return (React.createElement(ChatMessage, { variation: 'initial', Icon: TravelBotLogoImage, mb: 4, message: signedIn ? (React.createElement(Text, { fontSize: 2 }, "Looks like you're already signed in! You're welcome to ask additional questions if you have any!")) : (React.createElement(Flex, { flexDirection: 'column' },
            React.createElement(Text, { fontSize: 2, pb: 3 }, "Click the button below to Sign In."),
            React.createElement(Text, { fontSize: 2, pb: 2 }, "To safeguard your privacy, this chat will be cleared upon signing in."),
            React.createElement(Flex, { ml: 4, p: 2 },
                React.createElement(Button, { variation: 'subtle', ml: 2, onClick: onSigninClick || onClickHandler }, "Sign In")))) }));
}
export { SignInMarkerComponent };
//# sourceMappingURL=SignInMarkerComponent.js.map